export function getTitles(page: string): {
    pageTitle: string;
    pageSubTitle: string;
} {
    if (page.includes('automations/sending')) {
        return {
            pageTitle: 'Automated emails',
            pageSubTitle: 'Sending to your leads based on pipeline stage',
        };
    } else if (page.includes('automations/needs-attention')) {
        return {
            pageTitle: 'Needs attention',
            pageSubTitle: 'Automated emails that need attention before they can be sent',
        };
    } else if (page.includes('automations/ready-to-send')) {
        return {
            pageTitle: 'Ready to send',
            pageSubTitle: 'These emails were not able to send initially, but can now',
        };
    }

    // Fallback
    return {
        pageTitle: '',
        pageSubTitle: '',
    };
}
